<template>
  <div class="conmain">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-button type="primary" round @click="teacher_up('add','')">新增讲师</el-button>
    <el-table stripe :data="teacher_list.data" style="width: 100%">
      <el-table-column label="编号" prop="num" width="" sortable>
      </el-table-column>
      <el-table-column label="人物图" sortable>
        <template slot-scope="scope">
        <img :src="scope.row.img" alt="" style="height: 2rem;">
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="name" sortable>
      </el-table-column>
      <el-table-column label="状态" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.status=='1'">启用中</p>
           <p v-else>已禁用</p>
         </template>
      </el-table-column>
      <el-table-column align="right" width="150">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" @keyup.enter.native="search_click()" size="mini" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" @click="teacher_up('edit',scope.row.num)">编辑</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status!='1'" @click="teacher_up('del',scope.row.num)">启用</el-button>
          <el-button size="mini" type="danger" v-else @click="teacher_up('del',scope.row.num)">禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="teacher_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="teacher_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="teacher_list.total">
      </el-pagination>
    </div>

<el-dialog :title="nav_status.teacher_dialog_title" :visible.sync="nav_status.teacher_dialog">
     <p>讲师名:&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="teacher_edit.name" placeholder="请输入内容" style="width: 50%;"></el-input></p>
     <p style="width: 100%; ">封面
           <el-upload class=" eidtbtn"
                     ref="cropper"
                     action=""
                     accept="image/*"
                     drag
                     :auto-upload="false"
                     :show-file-list="false"
                     :on-change='change_img'>
                     请选择图片
                     <div  style="width: 100%; height: 80%; display: flex; justify-content: center;">
                       <img :src="teacher_edit.img" style=" height: 100%;" />
                     </div>
                   </el-upload>
                   </p>
     <p>简介 <div class="eidtbtn">
      <el-input  style="width: 71%;" :rows="6" type="textarea"  placeholder="请输入简介" v-model="teacher_edit.content"> </el-input></div>
     </p>
     <p>详情
     <div class="eidtbtn">
      <el-input  style="width: 71%;" :rows="6" type="textarea"  placeholder="请输入详情" v-model="teacher_edit.info"> </el-input></div></p>
      <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.teacher_dialog=false">取 消</el-button>
      <el-button type="primary" @click="teacher_save()">确 定</el-button>
    </div>
    </el-dialog>

  </div>
</template>

<script>
  import load from '../../../../components/load.vue';
  export default {
    data() {
      return {
        liad_show:true,
        nav_status:{
          teacher_dialog:false
        },
        teacher_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        teacher_edit:{},
        search: ''
      }

    },
    components: {
      load:load
    },
    mounted() {
      this.get_teacher()
    },
    methods: {
      search_click(){
        this.get_teacher()
      },
      get_teacher(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_teacher',{params:{'page':_this.teacher_list.current_page,'limit':_this.teacher_list.per_page,'type':'1','keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.teacher_list=res.data.data
              _this.teacher_list.per_page=parseInt(_this.teacher_list.per_page)
              _this.liad_show=false
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.teacher_list.current_page = 1;
        this.teacher_list.per_page = val
        this.get_teacher()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.teacher_list.current_page = val
        _this.get_teacher()
      },

      change_img(event){
        let _this=this
        _this.get_img_base64(event.raw).then(res => {
             _this.teacher_edit.img=res
         });
      },

      get_img_base64(file) {
          return new Promise(function(resolve, reject) {
              let reader = new FileReader();
              let imgResult = "";
              reader.readAsDataURL(file);
              reader.onload = function() {
                  imgResult = reader.result;
              };
              reader.onerror = function(error) {
                  reject(error);
              };
              reader.onloadend = function() {
                  resolve(imgResult);
              };
          });
      },

      teacher_up(type,num){
        let _this=this
        _this.teacher_edit.type=type
        if(type=='del'){
          _this.teacher_edit.num=num
          _this.teacher_save()
        }else if(type=='edit'){
          _this.get_teacher_info(num)
        }else{
          _this.teacher_edit={
            img:'',
            type:type
          }
          _this.nav_status.teacher_dialog=true
        }
      },

      get_teacher_info(num){
        let _this=this
        _this.axios.get('/v2/c_resource/get_teacher_info',{params:{'num':num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.teacher_edit=res.data.data
              _this.teacher_edit.type='edit'
              _this.nav_status.teacher_dialog=true
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      teacher_save(){
        let _this=this
        _this.axios.post('/v2/c_resource/teacher_up',{data:_this.teacher_edit}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_teacher()
              _this.nav_status.teacher_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      }


    },
  }
</script>

<style scoped>
  .conmain {
    width: 100%;
    height: 100%;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfCourse/Teacher.vue